module.exports = __webpack_public_path__ + "static/media/IMG.warning.7036d036.svg";


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-scaffold-framework/component/Message/IMG.warning.svg
// module id = 1387
// module chunks = 0